<template>
  <v-card class="my-4">
    <v-card-text>
      <v-subheader class="pa-0">{{
        $t("dashboard.selectEquipmentsVariables")
      }}</v-subheader>
      <v-autocomplete
        v-model="equipmentProfile.variables"
        :items="variables"
        multiple=""
        :disabled="!$store.getters['auth/adminAndUp']"
        chips
        :loading="loading"
        small-chips
        persistent-hint
        :item-text="variableName"
        return-object=""
        item-color="success"
        prepend-icon="mdi-database-search"
        @change="setVariables"
      >
      </v-autocomplete>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import variablesPool from "@/mixins/variablesPool";
import { db } from "@/plugins/db";
export default {
  mixins: [variablesPool],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapGetters("auth", ["isMetric"])
  },
  methods: {
    async setVariables() {
      this.loading = true;
      this.equipmentProfile.variables = this.equipmentProfile.variables.sort(
        (a, b) => a.code.localeCompare(b.code)
      );
      try {
        await db
          .collection("equipments")
          .doc(this.equipmentProfile.id)
          .update({
            variables: this.equipmentProfile.variables
          });
        this.$dialog.notify.success("Range was updated successfully", {
          position: "top-right",
          timeout: 5000
        });
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      }
      this.loading = false;
    },
    variableName(item) {
      let name = this.$t(`variables.${item.code}`);
      let group = item.groups;
      return `[${this.$t(`groups.${group}`)}] ${name}`;
    }
  }
};
</script>
